var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Content",
    {
      style: { "margin-left": "10px", "max-height": _vm.tableHeight },
      attrs: { id: "errorReportList" },
    },
    [
      _c(
        "div",
        { attrs: { slot: "search" }, slot: "search" },
        [
          _c(
            "Form",
            { attrs: { "label-width": 45, model: _vm.form, id: "searchForm" } },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "名称" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: 100, clearable: true },
                            model: {
                              value: _vm.form.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "name", $$v)
                              },
                              expression: "form.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "条形码", "label-width": 60 } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: 13, clearable: true },
                            on: {
                              input: function ($event) {
                                return _vm.toInt()
                              },
                            },
                            model: {
                              value: _vm.form.barCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "barCode", $$v)
                              },
                              expression: "form.barCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "手机号码", "label-width": 75 } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: { maxlength: 11, clearable: true },
                            on: {
                              input: function ($event) {
                                return _vm.pareInt("phone")
                              },
                            },
                            model: {
                              value: _vm.form.phone,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "phone", $$v)
                              },
                              expression: "form.phone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("Col", [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _vm._v("  "),
                        _c(
                          "Button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.search },
                          },
                          [_vm._v("查询")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "singleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.dataList,
            "header-cell-style": {
              background: "#f8f8f9",
              color: "#515a6e",
              "text-align": "center",
            },
            "row-class-name": _vm.tableRowClassName,
            "highlight-current-row": "",
            "highlight-selection-row": "",
            "row-key": "id",
            "max-height": _vm.tableHeight,
          },
          on: { "row-click": _vm.selectrow },
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "barCode",
              label: "条形码",
              "min-width": "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "",
              align: "center",
              prop: "name",
              label: "姓名",
              "min-width": "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "gender",
              label: "性别",
              "min-width": "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        scope.row.gender === 1
                          ? "男"
                          : scope.row.gender === 2
                          ? "女"
                          : ""
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "birthday",
              label: "出生日期",
              "min-width": "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "age",
              label: "年龄",
              "min-width": "80",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "phone",
              label: "手机号码",
              "min-width": "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "healthEvaluation",
              label: "健康评价",
              "show-overflow-tooltip": "",
              "min-width": "120",
            },
          }),
        ],
        1
      ),
      _c("Page", {
        staticStyle: { "margin-top": "10px" },
        attrs: {
          total: _vm.pageList.total,
          current: _vm.pageList.currentPage,
          "page-size": _vm.pageList.pageSize,
          "show-elevator": "",
          "show-sizer": "",
          "show-total": "",
          "page-size-opts": [10, 30, 50, 100],
        },
        on: {
          "on-change": _vm.chagecurrent,
          "on-page-size-change": _vm.chagepagesize,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }